import React from 'react';
import axios from 'axios';

class DownloadReport extends React.Component {
    state = {
        downloading: false,
        progress: 0 // State to manage progress bar
    };

    componentDidMount() {
        // console.log('Download Button Loaded');
    }

    triggerFileDownload = () => {
        this.setState({ downloading: true, progress: 0 });

        // Simulate progress
        this.progressInterval = setInterval(() => {
            this.setState(prevState => ({
                progress: prevState.progress >= 100 ? 0 : prevState.progress + 10
            }));
        }, 1000); // Update progress every 1 second

        const url = 'react/download'; // Update with your actual endpoint URL

        axios({
            url: url,
            method: 'GET',
            responseType: 'blob', // Important for handling the binary data of the file
        })
        .then((response) => {
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'downloaded_file.csv'; // Default filename if not set in header

            console.log(contentDisposition);
            if (contentDisposition) {
                const fileNameMatch = /filename="?([^"]+)"?/.exec(contentDisposition);
                console.log(fileNameMatch);
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = fileNameMatch[1];
                }
            }

            // Create a URL for the file
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // Set the file name from the header
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            
            this.setState({ downloading: false }); // Hide download indicator
        })
        .catch((error) => {
            console.error('Download error:', error);
            this.setState({ downloading: false }); // Hide download indicator
        });
    };
   
    componentWillUnmount() {
        clearInterval(this.progressInterval); // Clear interval when component unmounts
    }
    
    render() {
        const modalStyle = this.state.downloading ? { display: 'block' } : { display: 'none' };
        const backdropStyle = this.state.downloading ? { display: 'block', opacity: 0.5 } : { display: 'none' };

        return (
            <>
                <div className="modal-backdrop fade show" style={backdropStyle}></div>
                <div className="modal" style={modalStyle} role="dialog" aria-hidden={!this.state.downloading}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Downloading in progress</h5>
                            </div>
                            <div className="modal-body">
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped progress-bar-animated" 
                                         role="progressbar" 
                                         style={{ width: `${this.state.progress}%` }} 
                                         aria-valuenow={this.state.progress} 
                                         aria-valuemin="0" 
                                         aria-valuemax="100">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button onClick={this.triggerFileDownload} className="btn btn-primary btn-primary mb-2 mr-10">
                    <span className="btn-label"><i className="fas fa-download"></i></span>Download
                </button>
                {/* <button onClick={this.triggerFileDownload} className="btn btn-primary mt-1 mb-2 mr-10 waves-effect waves-light">
                    <span className="btn-label"><i className="fas fa-download"></i></span>Emails Only
                </button> */}
            </>
        );
    }
}

export default DownloadReport;
